import { Box, Button, HStack } from "@chakra-ui/react";
import { t } from "i18next";
import { OsaNode } from "../../../../../osaway/models/OsaNode";
import { NodePhoto } from "../../../../../shared/views/NodePhoto/NodePhoto";

const i18prefix = "map:routeSummary";

export const SelectFirstNodeThumbnail: React.FC<{
  firstNode?: OsaNode;
  selectNodeById: (nodeId: string) => void;
}> = ({ firstNode, selectNodeById }) => {
  if (!firstNode?.photo) return null;

  return (
    <HStack justifyContent={"center"}>
      <Box position="relative">
      <NodePhoto width={"300px"} rounded={"md"} node={firstNode} />
      <Button
        position="absolute"
        bottom={2}
        left="50%"
        transform="translateX(-50%)"
        alignSelf="center"
        colorPalette="primary"
        size="sm"
        disabled={!firstNode}
        onClick={() => {
          selectNodeById(firstNode.id);
        }}
      >
        {t(`${i18prefix}.selectFirst`)}
      </Button>
    </Box>
    </HStack>
    
  );
};
